import React, { Component } from 'react';
import {
  Button,
  Modal,
  ModalBody,
  Form,
  FormGroup,
  Label,
  FormFeedback,
  Input,
  InputGroup,
  InputGroupAddon
} from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import '../ModelComponent.scss';
import { string } from '../../../../localization';
import * as Constants from '../../../../utilities/constants/Constants';
import * as pageControllerActions from '../../../../redux/pageControllerActions';
import * as homeActions from '../../../../redux/homeActions';
import * as sizeHandler from '../../../../redux/actions/sizeHandler';

class CustomProduct extends Component {
  closeCustomSize = () => {
    const { dispatchers, hideComponents } = this.props;
    hideComponents();
    dispatchers.sizeHandler.customHeightChange(null);
    dispatchers.sizeHandler.customWidthChange(null);
  };

  goToNextPage = e => {
    const { dispatchers } = this.props;
    if (e.keyCode === Constants.ENTER_KEY_CODE && e.target.value !== '') {
      if (!dispatchers.pageControllerActions.shouldDisableNextButton()) {
        dispatchers.pageControllerActions.goToNextPage();
        dispatchers.homeActions.settingsWallChange('custom');
      }
    }
  };

  render() {
    const {
      customWall,
      dispatchers,
      customProductSizes,
      widthValid,
      heightValid,
      customizableWidth,
      customizableHeight,
      setCustomHeight,
      setCustomWidth,
      unitSystem
    } = this.props;

    const { iconUrl } = customProductSizes;
    const {
      widthErrorMessage,
      heightErrorMessage,
      activeErrorMessage
    } = customWall;

    let errorMessage = activeErrorMessage;
    if (errorMessage == '') {
      errorMessage =
        widthErrorMessage != '' ? widthErrorMessage : heightErrorMessage;
    }
    const externalCloseBtn = (
      <button type='button' className='close' onClick={this.closeCustomSize}>
        <img
          alt='close-button'
          src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAABBCAYAAAC5OQZxAAAABGdBTUEAALGPC/xhBQAAAdNJREFUaAXN2j1OwzAUAOA6ZYe9a48AYu1BEHfIzMycnAFxkK4IjsDKDgcg4b1gV4njJv55P7WUurErva8vcSQ/xWwUW13Xewj/CsdD0zSfSKnwQ6MhxhhzhNj32Fvcxmhi+r7fufiA+oLzgzjIZWaMcSjo30RBSxjxDMVg8MYWyVAsBi8dOygFww5KxbCCcjBsoFwMC6gEQw4qxZCCKDBkICoMCYgSUwyixhSBODDZIC5MFogTkwzixiSBJDDRIClMFEgSswqSxiyCNDBnQVqYIEgTMwNpYyYgi3mHHeUNToyb28S5gsB4jvr7sA2ymA/AXPsBJDEY21wSBkFXcDyHMgPjv13XPbZtO9Rt8McSDetDT3BZfgLBtlVVvWAGA3NsQxd3Dw0VNFw9cNluIVPf/l+H8R2Mnypc/jz1+amkZ1F3uKr8IJKoWfXDrrojInwYYmH8wPk8moEQoYkKgjRRZ0FaqEWQBmoVJI2KAkmiokFSqCSQBCoZxI3KAnGiskFcqCIQB6oYRI0iAVGiyEBUKFIQBYocVIpiAZWg2EC5KFZQDoodlIoSAaWgxECxKFHQGgrmZd9sQBC20L7PbULFM/RPmqIcBnfEaiCXKegn7w/9AUk21xvFj8GeAAAAAElFTkSuQmCC'
        />
      </button>
    );

    return (
      <Modal
        isOpen
        backdrop={false}
        fade={false}
        // toggle={dispatchers.toggleCustomWallModal}
        backdropClassName='customSizeModalBackdrop'
        modalClassName='customSizeModal d-table'
        size='lg'
        external={externalCloseBtn}
      >
        <p className='heading'>{string.SELECT_CUSTOM_SIZE_KEY}</p>
        <p className='custom-txt'>{string.SELECT_CUSTOM_KEY}</p>
        <ModalBody>
          <div className='first-box h-100 d-flex justify-content-center align-items-center'>
            <img alt='Custom-Size' src={iconUrl} />
          </div>
          <div className='second-box'>
            <Form
              className='second-box-form'
              onSubmit={dispatchers.homeActions.selectCustomWall}
            >
              <FormGroup className='custom-width'>
                <Label>{string.WIDTH_KEY}</Label>
                <InputGroup>
                  <div
                    className={`vaild-dimension dimension-valid ${
                      !widthValid ? null : 'invalid-dimension'
                    }`}
                  >
                    <Input
                      type='number'
                      bsSize='lg'
                      value={customizableWidth}
                      onKeyDown={this.goToNextPage}
                      onChange={e => {
                        setCustomWidth(e.target.value);
                        dispatchers.sizeHandler.customWidthChange(
                          e.target.value
                        );
                      }}
                    />
                  </div>
                  <InputGroupAddon addonType='append'>
                    <span className='position-absolute'>
                      {' '}
                      {unitSystem === Constants.IMPERIAL_KEY
                        ? string.INCHES_UNIT_STRING_KEY
                        : string.CM_KEY}
                    </span>
                  </InputGroupAddon>
                </InputGroup>
              </FormGroup>

              <FormGroup className='custom-height'>
                <Label>{string.HEIGHT_KEY}</Label>
                <InputGroup>
                  <div
                    className={`vaild-dimension dimension-valid ${
                      !heightValid ? null : 'invalid-dimension'
                    }`}
                  >
                    <Input
                      type='number'
                      bsSize='lg'
                      value={customizableHeight}
                      onKeyDown={this.goToNextPage}
                      onChange={e => {
                        setCustomHeight(e.target.value);
                        dispatchers.sizeHandler.customHeightChange(
                          e.target.value
                        );
                      }}
                    />
                  </div>
                  <InputGroupAddon addonType='append'>
                    <span className='position-absolute'>
                      {' '}
                      {unitSystem === Constants.IMPERIAL_KEY
                        ? string.INCHES_UNIT_STRING_KEY
                        : string.CM_KEY}
                    </span>
                  </InputGroupAddon>
                </InputGroup>
              </FormGroup>

              <FormFeedback className='d-block pt-0'>
                {errorMessage}
              </FormFeedback>
              <Button className='d-none' />
            </Form>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    customProductSizes: state.modal.productSizes.custom,
    customWall: state.home.customWall,
    widthValid: state.home.customWall.widthValid,
    heightValid: state.home.customWall.heightValid,
    unitSystem: state.home.unitSystem,
    language: state.home.language
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      homeActions: bindActionCreators(homeActions, dispatch),
      sizeHandler: bindActionCreators(sizeHandler, dispatch),
      pageControllerActions: bindActionCreators(pageControllerActions, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomProduct);
